import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { toast } from 'vue-sonner';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function copyToClipboard(text: string) {
  if (navigator.clipboard && window.isSecureContext) {
    const copy = navigator.clipboard.writeText(text);
    toast.success('Gekopieerd naar klembord');
    return copy;
  }
}
